/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class Notebook {
  /**
  * The unique identifier of the notebook
  */
  'id': string;
  /**
  * The display name of the notebook
  */
  'name': string;
  /**
  * Optional description of the notebook
  */
  'description'?: string;
  /**
  * The user who created the notebook
  */
  'createdBy': string;
  /**
  * The timestamp when the notebook was created
  */
  'createdAt': Date;
  /**
  * The timestamp when the notebook was last updated
  */
  'updatedAt': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdBy",
      "baseName": "createdBy",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return Notebook.attributeTypeMap;
  }

  public constructor() {
  }
}

